var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevplan = function SvgDevplan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.922 16.491a3.08 3.08 0 0 1 2.364-1.107H27.69a6.153 6.153 0 0 0 6.153-6.153V6.154A6.153 6.153 0 0 0 27.69.001h-2.405c-.913 0-1.78.406-2.364 1.107l-2 2.4a3.08 3.08 0 0 1-2.364 1.108H6.153A6.153 6.153 0 0 0 0 10.769v3.077a6.153 6.153 0 0 0 6.153 6.153h2.405c.913 0 1.779-.405 2.364-1.107zM29.228 6.154c0-.85-.689-1.538-1.538-1.538h-4.713c-.913 0-1.779.406-2.363 1.107l-2 2.4a3.08 3.08 0 0 1-2.364 1.108H6.153c-.85 0-1.538.689-1.538 1.538v3.077c0 .85.689 1.538 1.538 1.538h4.713c.913 0 1.779-.405 2.363-1.107l2-2.4a3.08 3.08 0 0 1 2.364-1.108H27.69c.85 0 1.538-.688 1.538-1.538z",
    clipRule: "evenodd"
  })));
};
export default SvgDevplan;